module.exports = __webpack_public_path__ + "img/eprice-button-red-02hover.d7eeecac.png";